module.exports = __webpack_public_path__ + "media/images/flags/gi-37c4c24366a251ba5f2eb21f198cd314.svg";